import { BASE_URL, GET, REGULATORY_COUNTRY } from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchregulatoryCountry = async (requestId) => {
  const token = await getAccessToken();
  const url = `${BASE_URL}${REGULATORY_COUNTRY}`;
  return fetch(url, {
      method: GET,
      headers: {
        "Content-Type": "application/json",
        "userauth" : `bearer ${token}`
      },
    })
    .then(statusParsing)
    .then(jsonParsing);
};
